import { apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { BaseApiDatasourceSpec } from "@/io/datasource/BaseApiDatasource.ts";
import { MedicalDeviceDTO } from "@/models/DeviceModel.ts";
import { GlycemiaDTO } from "@/models/GlycemiaModel.ts";
import { BasalRateChangeDTO, BolusInsulinDTO } from "@/models/InsulinModel.ts";
import { cz } from "@/utils/zodUtils.ts";

export class DiabetesRepository {
  constructor(private readonly datasource: BaseApiDatasourceSpec = apiDataSource) {}

  bulkCreateInsulin = async (device: MedicalDeviceDTO, measurements: BolusInsulinDTO[]) =>
    this.datasource.post<unknown>(`/uploader/insulin/bulk_create/`, cz.ignore(), {
      device_sn: device.serial_number,
      device_name: device.device_type_name,
      measurements,
    });

  bulkCreateBasalRates = async (device: MedicalDeviceDTO, measurements: BasalRateChangeDTO[]) =>
    this.datasource.post<unknown>(`/uploader/basal_rates/bulk_create/`, cz.ignore(), {
      device_sn: device.serial_number,
      device_name: device.device_type_name,
      measurements,
    });

  bulkCreateGlycemia = async (device: MedicalDeviceDTO, measurements: GlycemiaDTO[]) =>
    this.datasource.post<unknown>(`/uploader/glycemia/bulk_create/`, cz.ignore(), {
      device_sn: device.serial_number,
      device_name: device.device_type_name,
      measurements,
    });
}
